import { render } from "./OrganigrammeView.vue?vue&type=template&id=b208789a"
import script from "./OrganigrammeView.vue?vue&type=script&lang=js"
export * from "./OrganigrammeView.vue?vue&type=script&lang=js"

import "./OrganigrammeView.vue?vue&type=style&index=0&id=b208789a&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__